import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  restaurantApprovals: [],
};

const requestApprovalSlice = createSlice({
  name: "requestApproval",
  initialState,
  reducers: {
    setRequestApproval: (state, action) => {
      state.restaurantApprovals = action.payload;
    },
  },
});

export const { setRequestApproval } = requestApprovalSlice.actions;
export default requestApprovalSlice.reducer;
